/*
	GLOBAL DEFINES

	Add properties that will be used by the library to get data.

 */

const SERVER_API_URL = '/gtxapi';

//Add more action constants under server
const libraryConfiguration = {
	SERVER: {
		ARTICLE_LIST: SERVER_API_URL + '/articlelist',
		ISSUE_LIST: SERVER_API_URL + '/issuelist',
		ISSUE_NAMES: SERVER_API_URL + '/issuenamelist',
		SEARCH: SERVER_API_URL + '/search',
		ISSUE_TAGS : SERVER_API_URL + '/issuetags',
		IN_APP_PRODUCTS: SERVER_API_URL + '/products',
		PUBLICATION : SERVER_API_URL + '/publication',
		SUBSCRIBER : SERVER_API_URL + '/subscriber',
		PURCHASE : SERVER_API_URL + '/purchase',
		REPLICA_LIST : SERVER_API_URL + '/replicalist',
		ACCESS : SERVER_API_URL + '/access',
		HIGHLIGHTS :  SERVER_API_URL + '/user/highlightlist'
	},

	DEFAULTS: {
		DEVICESIZEBREAKPOINTS: {xs: 0, sm: 568, md: 768, lg: 1024, xl: 1280, xxl: 1400},
		TARGETPRIORITY: ['articleViewer','replicaViewer','articleList','replicaList','libraryTarget','searchResults']
	}


};
export default libraryConfiguration;


const ExternalUrl = {
	PLACEHOLDER: {
		GTXCEL_LIBRARY: 'https://via.placeholder.com/172/0054AD/FFFFFF?text=GTxcel Library',
		LANDSCAPE_THUMBNAIL_SMALL: 'https://via.placeholder.com/444x300/?text=Upload%20a%20Landscape%20Thumbnail%20image',
		LANDSCAPE_THUMBNAIL_MEDIUM: 'https://via.placeholder.com/630x300/?text=Upload%20a%20Landscape%20Thumbnail%20image',
		PORTRAIT_LARGE: 'https://via.placeholder.com/375x510/?text=Upload%20an%20Extra%20Large%20Portrait%20image',
		PORTRAIT_EXTRA_LARGE: 'https://via.placeholder.com/1440x500/?text=Upload%20an%20Extra%20Large%20Landscape%20image',
	}
};
export {ExternalUrl};
